module.exports = __webpack_public_path__ + "media/images/locations/sm/canada-c9427f7035ff4c57a687776d74acdf45.jpg";